export default function Divider(props: {
  color: string;
  marginTop?: string;
  marginBottom?: string;
  marginLeft?: string;
  marginRight?: string;
}) {
  return (
    <div
      style={{
        width: "100%",
        height: "0.0625rem",
        backgroundColor: props.color,
        marginTop: props.marginTop,
        marginBottom: props.marginBottom,
        marginLeft: props.marginLeft,
        marginRight: props.marginRight,
      }}
    ></div>
  );
}
